import React from "react";
import ChartCard from "./ChartCard";
import Pie from "../charts/Pie";

export default class StatusDistributionCard extends React.Component{
    render(){
        return (
            <ChartCard title="Appliance status distribution">
                <Pie legend={true} resource="appliance-status-distribution" />
            </ChartCard>
        )
    }
}